import { BackButton, TopBar } from '@capsicum/common-web';
import { type V2FTMigrationScreenContainerProps } from '@capsicum/features/nc-wallet/shared';
import styled from 'styled-components';

export const V2FTMigrationScreenContainer = ({
	children,
	footer,
	onBack,
	title
}: V2FTMigrationScreenContainerProps) => {
	return (
		<S.Wrapper>
			<TopBar
				headerLeft={onBack && <BackButton testID="V2FTMigrationScreen-screen-back" onClick={onBack} />}
				testID="V2FTMigrationScreen-screen-topbar"
				textColor="enabled"
				title={title}
				variant="subpage"
			/>

			<S.Body>
				<S.Content>{children}</S.Content>
			</S.Body>

			{footer && (
				<S.Footer>
					<S.FooterContent aria-label="Footer">{footer}</S.FooterContent>
				</S.Footer>
			)}
		</S.Wrapper>
	);
};

namespace S {
	export const Wrapper = styled.div`
		height: 100vh;
		display: flex;
		flex-direction: column;
		background-color: ${({ theme }) => theme.colors.backgrounds.main.screen};
	`;

	export const Body = styled.div`
		flex: 1;
		width: 100%;
		display: flex;
		overflow-y: auto;
		align-items: center;
		flex-direction: column;
		padding: ${({ theme }) => theme.spacings.small};
	`;

	export const Content = styled.div`
		width: 100%;
		max-width: 500px;
	`;

	export const Footer = styled.div`
		display: flex;
		justify-content: center;
		padding-top: ${({ theme }) => theme.spacings.xsmall};
		padding-left: ${({ theme }) => theme.spacings.small};
		padding-right: ${({ theme }) => theme.spacings.small};
		padding-bottom: ${({ theme }) => theme.spacings.large};
		background-color: ${({ theme }) => theme.colors.backgrounds.main.container};
	`;

	export const FooterContent = styled.div`
		width: 100%;

		@media only screen and (min-width: 380px) {
			flex: 0 1 500px;
		}
	`;
}
